export const formatShivar = (name: string, marathiName?: string | null): string =>
  marathiName ? `${name}(${marathiName})` : name;
